import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import {
  BackgroundWithCurve,
  CaseStudiesImageCard,
  CaseStudyHeading,
  Section,
} from '../../utils/CaseStudiesComponents';

const NestleS26 = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Nestle S26',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Retail and E-Commerce',
                path: '/industries/retail-ecommerce',
              },
            ],
          }}
        />
        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center    h-16 w-16 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.NestleLogo ? (
                <img
                  className="h-20 w-20 md:h-32 md:w-32 lg:h-40 lg:w-40 object-contain"
                  src={imagePath?.NestleLogo}
                  alt="Nestle Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-5 justify-center">
              <CaseStudyHeading
                title="Nestle S26"
                desc="Leverage AR to educate influencers regarding benefits of the product"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.S26Video && (
                <video
                  src={videoPath?.S26Video}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Overview"
            subtitle="Subtitle mentioned over here  to boot."
            content="Nestle’s objective was to increase sales of their baby formula product by creating promotional campaign
            to the Doctors to educate them with the nutritional benefits for the infants. Once the Doctors are fully 
            aware they would then educate the new-Mom’s regarding the nutritional benefits of the S26. S26 is a 
            brand of infant and follow-on milk formula designed for different developmental stages, containing key 
            nutrients like DHA, Choline, Iron, and vitamins (A, D, Selenium) to support brain development, vision, 
            immunity, and bone growth when breastfeeding is not possible. It comes in various Gold stages 
            (1, 2, 3, ProKids) for newborns, infants, and toddlers. "
          />

          <Section
            title="Execution"
            content={[
              'S26 gave the challenge to SpatialGrid to come up with a proposal to develop a solution that will be easyto use for the Doctors in addition to making a memorable experience for the visitors to the Clinic. The solution leveraged AR technology to make it an education and interactive experience for both the Doctor and his constituents. A quiz is created for the users to interact with and create exciting avatars of themselves along with offers for gift coupons and such to continue their attention.',
              'For Nestlé’s S26 brand, we successfully delivered an Instant App–based AR experience designed to drive deeper engagement and actionable insights. The solution enabled immersive, real-life–like environments while capturing detailed interaction analytics for both doctors and users, including location-wise and time-based engagement data. An AI-powered avatar creation feature allowed users to generate and share personalized avatars with friends and family, extending organic reach. The platformalso featured an intuitive content management UI, enabling dynamic updates without redevelopment, and robust scene-building capabilities to create highly realistic, interactive AR environments.',
            ]}
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.S26First}
                title="AR Experience Interface"
              />
              <CaseStudiesImageCard
                image={imagePath?.S26Second}
                title="Interactive Product Display"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content="Development of the project from concept to deployment was completed in 12 days reducing the TCO significantly and improving the time to market. Because of this solution framework the footfall reached above 90% although the target was only 60% as the quality is of very high standard. Additionally, the user satisfaction reached 90% as well due to the high-fidelity avatars generated dynamically. The timeline of turn-around time of 12 days included the process to publish the instant apps in iOS and Android application stores respectively."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;

export default NestleS26;
